import { gql }  from '@apollo/client';

const CAN_DISPLAY_INITIATE_REFERRAL_BUTTON = gql`
  query($memberId: ID!) {
    member(id: $memberId) {
      canDisplayInitiateReferralButton
    }
  }
`;

export default CAN_DISPLAY_INITIATE_REFERRAL_BUTTON;
